import React from 'react'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { Button, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import clsx from 'clsx'

export const PaymasterWarning = ({ setActiveMethod }) => {
  const { t } = useTranslation()

  return (
    <Grid
      className={clsx(styles['billing__notification'], styles['billing__notification_notice'])}
      direction={'row'}
      wrap={false}
      gap={16}
    >
      <Icon
        size={'m'}
        name={'status warning'}
        color={'Accent-Notice-Secondary'}
      />
      <Grid
        direction={'column'}
        gap={4}
      >
        <Typography variant={'Subtitle-20'}>
          {t('billing::payment_method_warning_message.heading')}
        </Typography>
        <div>
          <Typography
            component={'span'}
            variant={'Body-20'}
          >
            <Trans i18nKey="billing::payment_method_warning_message.summary">
              Если вы хотите пополнить баланс с помощью корпоративной карты, пожалуйста, выберите
              способ
              <Button
                color={'Label-GU-Primary'}
                component={'span'}
                variant={'link'}
                onClick={() => setActiveMethod('paymaster_service')}
              >
                {t('billing::payment_method_warning_message.button')}
              </Button>
            </Trans>
          </Typography>
        </div>
      </Grid>
    </Grid>
  )
}

PaymasterWarning.propTypes = {
  t: PropTypes.func,
  setActiveMethod: PropTypes.func,
}
